// Keep the full Bootstrap plugin API on one shared source EventHandler registry.
import 'bootstrap/js/src/alert';
import 'bootstrap/js/src/button';
import 'bootstrap/js/src/carousel';
import 'bootstrap/js/src/collapse';
import EventHandler from 'bootstrap/js/src/dom/event-handler';
import Dropdown from 'bootstrap/js/src/dropdown';
import 'bootstrap/js/src/modal';
import 'bootstrap/js/src/offcanvas';
import 'bootstrap/js/src/popover';
import 'bootstrap/js/src/scrollspy';
import 'bootstrap/js/src/tab';
import 'bootstrap/js/src/toast';
import 'bootstrap/js/src/tooltip';

const keydownEvent = 'keydown.bs.dropdown.data-api';
const menuSelector = '.dropdown-menu';

// DS menus share Bootstrap classes; only legacy menus belong to its capture handler.
EventHandler.off(
  document,
  keydownEvent,
  menuSelector,
  Dropdown.dataApiKeydownHandler,
);
EventHandler.on(
  document,
  keydownEvent,
  `[data-bs-toggle="dropdown"] ~ ${menuSelector}`,
  function (event) {
    // A nested DS toggle sits in the outer legacy menu but owns its keyboard events.
    if (
      !event.target.closest('.DropdownToggle') &&
      event.target.closest(menuSelector) === this
    ) {
      Dropdown.dataApiKeydownHandler.call(this, event);
    }
  },
);
